import { render, staticRenderFns } from "./PolymorphicReferenceCard.vue?vue&type=template&id=543349aa&"
import script from "./PolymorphicReferenceCard.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceCard.vue?vue&type=script&lang=js&"
import style0 from "./PolymorphicReferenceCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports